module.exports = __webpack_public_path__ + "img/approve.7e46fb10.svg";